import React, { useEffect, useState } from 'react';

import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { find } from 'lodash/fp';

import axios from '../modules/axios';

// This autocomplete search will make ONE API call to populate the select from the initial props
const OneTimeAutocompleteSearch = ({
  resource,
  attribute,
  attributeId,
  associations,
  filters,
  value,
  optionLabel,
  onChange,
  sort,
  disabled,
  limit = 200,
  ...other
}) => {
  const [options, setOptions] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const filtersUrl = [];
    for (let attr in filters) {
      filtersUrl.push(`${attr}=${filters[attr]}`);
    }

    if (associations) filtersUrl.push(`_associations=${associations}`);
    if (sort) filtersUrl.push(`_sort=${sort}`);
    filtersUrl.push(`_limit=${limit}`);

    axios.get(`${resource}?${filtersUrl.join('&')}`).then(res => {
      setOptions(res.data);
      setLoaded(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!loaded) {
    return null;
  }

  return (
    <Autocomplete
      autoComplete
      freeSolo
      getOptionLabel={optionLabel ? optionLabel : option => option[attribute]}
      options={options}
      renderInput={params => <TextField {...params} {...other} variant='outlined' fullWidth />}
      onChange={onChange}
      defaultValue={value ? find({ [attributeId]: value }, options) : null}
      disabled={disabled}
    />
  );
};

export default OneTimeAutocompleteSearch;
